import axios from ".";

export interface TermsInfo {
  version: string;
  filename: string;
  filename_hash: string;
  content_hash: string;
}

export interface AcceptTermsRequest {
  filename_hash: string;
  content_hash: string;
}

/**
 * Get Terms and Conditions information (version, filename, hashes)
 * @returns Promise with terms information
 */
export const getTermsInfo = () => {
  return axios.get<{ status: string; data: TermsInfo }>("/terms/info");
};

/**
 * Get the URL for the Terms and Conditions PDF document
 * @returns The URL string for the terms document endpoint
 */
export const getTermsDocumentUrl = () => {
  return `${import.meta.env.VITE_API_URL}/terms/document`;
};

/**
 * Accept Terms and Conditions
 * @param request Contains the SHA256 hashes for filename and content
 * @returns Promise with updated user data
 */
export const acceptTerms = (request: AcceptTermsRequest) => {
  return axios.post("/auth/accept-terms", request);
};
